export const PCR_FINALIZADA = 'PCR_FINALIZADA';
export const pcrFinalizada = pcrFinalizada => ({
  type: PCR_FINALIZADA,
  payload: {
    pcrFinalizada
  }
});



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/pcr/pcr.action.js